export enum ScoreBoardType {
  RENOVATE = 'renovate',
  SECRETS = 'secrets',
  VULNERABILITIES = 'vulnerabilities',
  COST = 'cost',
}
